import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "activity-view content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item-box col left" }
const _hoisted_6 = { class: "activity-title" }
const _hoisted_7 = {
  key: 0,
  class: "activity-time gray"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  id: "links",
  class: "row col left"
}
const _hoisted_11 = {
  key: 0,
  class: "item-box col fill"
}
const _hoisted_12 = { class: "activity-title" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "left" }
const _hoisted_17 = { class: "right" }
const _hoisted_18 = {
  key: 2,
  id: "links",
  class: "row col left"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  class: "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notify_box = _resolveComponent("notify-box")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ blur: !_ctx.time })
    }, [
      _createElementVNode("div", {
        class: "title large row link",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gg-chevron-left" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.activity?.name), 1)
      ]),
      (_ctx.success)
        ? (_openBlock(), _createBlock(_component_notify_box, {
            key: 0,
            type: "success"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode(" Your order was successfully updated ", -1)
            ])),
            _: 1,
            __: [2]
          }))
        : _createCommentVNode("", true),
      (_ctx.paid)
        ? (_openBlock(), _createBlock(_component_notify_box, {
            key: 1,
            type: "success"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Your order was successfully paid ", -1)
            ])),
            _: 1,
            __: [3]
          }))
        : _createCommentVNode("", true),
      (_ctx.reschedulePolicy)
        ? (_openBlock(), _createBlock(_component_notify_box, {
            key: 2,
            type: "warn"
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("h6", null, "Reschedule Policy", -1)),
              _createElementVNode("div", { innerHTML: _ctx.reschedulePolicy }, null, 8, _hoisted_2)
            ]),
            _: 1,
            __: [4]
          }))
        : _createCommentVNode("", true),
      (_ctx.cancellationPolicy)
        ? (_openBlock(), _createBlock(_component_notify_box, {
            key: 3,
            type: "warn"
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("h6", null, "Cancellation Policy", -1)),
              _createElementVNode("div", { innerHTML: _ctx.cancellationPolicy }, null, 8, _hoisted_3)
            ]),
            _: 1,
            __: [5]
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.activity?.name), 1),
            (_ctx.time?.AppointmentTypeKey != 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.time?.AppointmentDate), 1),
                  (_ctx.time?.AppointmentTypeKey == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " @ " + _toDisplayString(_ctx.time?.TimeString), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "separator" }, null, -1)),
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "activity-title" }, "Guests", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.time?.Rates.filter((r) => r.Participants > 0), (rate) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "activity-time gray",
                key: rate.EntityHierarchyRateKey
              }, _toDisplayString(rate.Name) + " x " + _toDisplayString(rate.Participants), 1))
            }), 128))
          ]),
          (_ctx.addons.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "activity-title" }, "Add ons", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.time?.AddOns, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "activity-time gray",
                    key: item.ProductKey ?? -1
                  }, _toDisplayString(item.AddOnName) + " x " + _toDisplayString(item.Quantity), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.activity?.activity.ShowEditActivityButton)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "blue link",
                  to: { name: 'OrderTimeWarn', params: { next: 'OrderTimeEdit' } }
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" Edit booking ", -1)
                  ])),
                  _: 1,
                  __: [8]
                }))
              : _createCommentVNode("", true),
            (_ctx.activity?.activity.ShowCancelActivityButton)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "blue link",
                  to: { name: 'OrderTimeWarn', params: { next: 'OrderTimeCancel' } }
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode(" Cancel booking ", -1)
                  ])),
                  _: 1,
                  __: [9]
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.time && _ctx.time?.TotalConsentsRequired && _ctx.waiverRequired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "left" }, "Waivers", -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["right", _ctx.time.Consents.length < _ctx.time.TotalConsentsRequired ? { red: true } : { green: true }])
                    }, _toDisplayString(_ctx.consents.length) + "/" + _toDisplayString(_ctx.time.TotalConsentsRequired) + " completed", 3)
                  ])
                ])
              ]),
              (_ctx.loadingWaivers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createVNode(_component_small_loader)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.consents.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consents, (consent) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "activity-item gray row",
                        key: consent.ConsentKey
                      }, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(consent.FirstName) + " " + _toDisplayString(consent.LastName), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.agreed(consent)), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.canAddWaiver)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("a", {
                      class: "link blue",
                      href: _ctx.time.ConsentUrl,
                      target: "_blank"
                    }, "Add waiver", 8, _hoisted_19)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.showModal && _ctx.activity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_router_view, { class: "modal-content" })
        ]))
      : _createCommentVNode("", true)
  ]))
}